module.exports = __webpack_public_path__ + "static/Friday-Orbica-Digital-209b6bcc1bc863d146884eedd138970d.mp4";